export enum EAgencyProducts {
  AllProductsAndExperience = '/agency/allProductsAndExperience',
  SubmitProductAndExperienceRate = '/agency/submitProductAndExperienceRate',
  UpdateProductAndExperienceRate = '/agency/updateProductAndExperienceRate',
  RemoveProductAndExperienceRate = '/agency/removeProductAndExperienceRate',
}

export enum EProducts {
  RequestNewProduct = '/products/request-new',
};